 /*=========================================================================================
  File Name: mutations.js
  Description: Categories Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Categories State Module
  Author: Tan Tran
==========================================================================================*/
export default {

    SET_CATEGORIES_STATE ( state, payload ) {

        state.categories = payload;
    },

    ADD_CATEGORY_STATE( state, payload ) {
        state.categories.push(payload);
    },

    UPDATE_CATEGORY_STATE(state, payload) {
        
        let index = state.categories.findIndex(c => c.cateogryId == payload.categoryId);

        if(index > -1) {
            state.categories[index] = payload;
        }
    }
}